/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PuntoDiRaccoltaUpdateDTO
 */
export interface PuntoDiRaccoltaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    comuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    comune?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    localita?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    cap?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    indirizzo?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    numeroCivico?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    note?: string;
    /**
     * 
     * @type {number}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    capienzaMassima?: number;
    /**
     * 
     * @type {number}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    latitudine?: number;
    /**
     * 
     * @type {number}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    longitudine?: number;
    /**
     * 
     * @type {string}
     * @memberof PuntoDiRaccoltaUpdateDTO
     */
    informazioniDiAccesso?: string;
}

/**
 * Check if a given object implements the PuntoDiRaccoltaUpdateDTO interface.
 */
export function instanceOfPuntoDiRaccoltaUpdateDTO(value: object): value is PuntoDiRaccoltaUpdateDTO {
    return true;
}

export function PuntoDiRaccoltaUpdateDTOFromJSON(json: any): PuntoDiRaccoltaUpdateDTO {
    return PuntoDiRaccoltaUpdateDTOFromJSONTyped(json, false);
}

export function PuntoDiRaccoltaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PuntoDiRaccoltaUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'comuneId': json['comuneId'] == null ? undefined : json['comuneId'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'comune': json['comune'] == null ? undefined : json['comune'],
        'localita': json['localita'] == null ? undefined : json['localita'],
        'cap': json['cap'] == null ? undefined : json['cap'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'numeroCivico': json['numeroCivico'] == null ? undefined : json['numeroCivico'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
        'capienzaMassima': json['capienzaMassima'] == null ? undefined : json['capienzaMassima'],
        'latitudine': json['latitudine'] == null ? undefined : json['latitudine'],
        'longitudine': json['longitudine'] == null ? undefined : json['longitudine'],
        'informazioniDiAccesso': json['informazioniDiAccesso'] == null ? undefined : json['informazioniDiAccesso'],
    };
}

export function PuntoDiRaccoltaUpdateDTOToJSON(value?: PuntoDiRaccoltaUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'regioneId': value['regioneId'],
        'provinciaId': value['provinciaId'],
        'comuneId': value['comuneId'],
        'nazioneId': value['nazioneId'],
        'regione': value['regione'],
        'provincia': value['provincia'],
        'comune': value['comune'],
        'localita': value['localita'],
        'cap': value['cap'],
        'indirizzo': value['indirizzo'],
        'numeroCivico': value['numeroCivico'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
        'capienzaMassima': value['capienzaMassima'],
        'latitudine': value['latitudine'],
        'longitudine': value['longitudine'],
        'informazioniDiAccesso': value['informazioniDiAccesso'],
    };
}

